module.exports = __webpack_public_path__ + "static/media/bottom.32d0ccbf.webm";